import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import {Dog} from '../../../classes/dog';
import config from '../../../config';
import {kanLoadingService} from "./loading";

@Injectable()
export class kanDogsService {
    constructor(private http: HttpClient,
                private loadingService: kanLoadingService) {
    }

    public getDogs(filter): Promise<Dog[]> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/dogs`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let dogs = response.map((item) => {
                        item.birthday = item.birthday ? new Date(item.birthday) : null;
                        item.membershipDate = item.membershipDate ? new Date(item.membershipDate) : null;
                        item.membershipRenewalDate = item.membershipRenewalDate ? new Date(item.membershipRenewalDate) : null;
                        return item;
                    });
                    resolve(dogs as Dog[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public countDogs(where: any = {}): Promise<number> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('where', JSON.stringify(where));
            this.http.get(`${config.apiRootUrl}/api/dogs/count`, {params: params})
                .toPromise()
                .then((response: any) => {
                    resolve(response.count as number);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getDog(id: string): Promise<Dog> {
        return new Promise((resolve, reject) => {
            let filter = {};
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/dogs/${id}`, {params: params})
                .toPromise()
                .then((response: any) => {

                    response.birthday = response.birthday ? new Date(response.birthday) : null;
                    resolve(response as Dog);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public addDog(dog: Dog): Promise<Dog> {
        this.loadingService.show();
        dog = this.cleanDog(dog);
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/dogs`, dog)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as Dog);
                })
                .catch((error) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public updateDog(dog: Dog): Promise<Dog> {
        this.loadingService.show();
        dog = this.cleanDog(dog);
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/dogs/${dog.id}`, dog)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as Dog);
                })
                .catch((error) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public removeDog(dog: Dog): Promise<boolean> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/dogs/${dog.id}/deactivate`, {})
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve();
                })
                .catch((error) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public updateMembershipType(dog: Dog, membershipTypeId: string, date: Date = null, renewalDate: Date = null): Promise<boolean> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/dogs/${dog.id}/membershipType`, {
                membershipTypeId: membershipTypeId,
                date: date,
                renewalDate: renewalDate
            })
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve();
                })
                .catch((error) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    private cleanDog(dog: Dog): Dog {
        Object.keys(dog).forEach((key) => {
            if (dog[key] === '') {
                dog[key] = null;
            }
        });
        return dog;
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/dogs.ts